import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Benefits/MemberDirectory/components/SectionHowItWorks/SectionHowItWorks.module.scss';
import { howItWorksItems } from 'sections/Benefits/MemberDirectory/data';
import { HowItWorksItem } from 'sections/Benefits/MemberDirectory/types';
import useWindowSize from 'utils/hooks/useWindowSize';

const cn = classNames.bind(styles);

const SectionHowItWorks = (): ReactElement => {
  const { width: screenWidth } = useWindowSize(); 

  const howItWorksListItems = howItWorksItems.map((item: HowItWorksItem) => {
    return (
      <div className={cn('list-item')} key={item.id}>
        <div className={cn('list-item__icon-box')}>
          <img src={`/images/pages/Benefits/MemberDirectory/${item.iconName}`} alt="services" />
          <img
            className={cn('list-item__line')}
            src={screenWidth >= 769 ? `/images/pages/Benefits/MemberDirectory/${item.svgName}` : `/images/pages/Benefits/MemberDirectory/${item.svgNameMobile}`}
            alt=""
          />
        </div>
        <h3 className={cn('list-item__title')}>{item.title}</h3>
        <p className={cn('list-item__description')}>{item.description}</p>
      </div>
    );
  });
  return (
    <section className={cn('how-it-works')}>
      <div className={cn('container')}>
        <h2 className={cn('how-it-works__title')}>How it works</h2>
        <ul className={cn('how-it-works__list')}>{howItWorksListItems}</ul>
      </div>
    </section>
  );
};

export default SectionHowItWorks;